// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ReactGridGallery_tile{background-color:rgba(0,0,0,0) !important}", "",{"version":3,"sources":["webpack://./src/components/DropzoneModal/style.scss"],"names":[],"mappings":"AAAA,uBACE,yCAAA","sourcesContent":[".ReactGridGallery_tile {\n  background-color: transparent !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
